import React from "react";
import css from "./MobileStepContentElementWrapper.module.css";

interface MobileStepContentElementWrapperProps {
    children: React.ReactNode;
}

export const MobileStepContentElementWrapper: React.FC<MobileStepContentElementWrapperProps> = (
    { children}) => {

    return (
        <div className={css.wrapper}>
            {children}
        </div>
    )
}